import type AhaEditorV2Controller from '../../controllers/AhaEditorV2Controller';
import type Tool from '../../tools/Tool';
import tools from '../../tools';
import React from 'react';
import { type Editor } from 'slate';
import styles from './Toolbar.module.css';
import classnames from 'classnames';

const ToolbarMenuItem = ({
  editor,
  controller,
  tool,
}: {
  editor: Editor;
  controller: AhaEditorV2Controller;
  tool: typeof Tool;
}) => {
  const shortcut = tool._shortcut?.pretty;
  let component = (
    <a
      onClick={(event) =>
        tools.fireToolAction(tool, event, { editor, controller })
      }
      aria-label={tool.toolName}
      className={classnames(styles.toolbarMenuItem, tool.menuItemClass)}
    >
      <span className={styles.toolbarMenuItemLabel}>
        {tool.renderMenuIcon({ editor })}
        {tool.label}
      </span>

      {shortcut && (
        <span className={styles.toolbarMenuItemShortcut}>{shortcut}</span>
      )}
    </a>
  );

  if (tool.toolbarSubmenu) {
    const ToolbarSubmenu = tool.toolbarSubmenu();
    component = (
      <ToolbarSubmenu
        editor={editor}
        controller={controller}
        tool={tool}
        isSubmenu
      />
    );
  }

  return (
    <aha-menu-item
      disabled={tool.isEnabled({ editor, controller }) ? null : true}
      selected={
        !tool.toolbarSubmenu && tool.isActive({ editor, controller })
          ? true
          : null
      }
    >
      {component}
    </aha-menu-item>
  );
};

export default ToolbarMenuItem;
